import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, takeUntil } from 'rxjs';
import { ReportList } from 'src/app/Modules/informate/models/reports/data-sheet-report.model';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { ReportApiService } from 'src/app/services/report.api.service';

@Component({
    selector: 'app-reports-list',
    templateUrl: './reports-list.component.html',
    styleUrls: ['./reports-list.component.scss'],
})
export class ReportsListComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    defaultReport: ReportList[];
    customReport: ReportList[];

    constructor(
        private ngxUiLoaderService: NgxUiLoaderService,
        private reportApiService: ReportApiService,
        private customToastService: CustomToastService,
        private cd: ChangeDetectorRef,
        private transLocoService: TranslocoService
    ) {}

    ngOnInit(): void {
        this.LoadReportList();
    }

    LoadReportList() {
        this.ngxUiLoaderService.start();
        this.reportApiService
            .getReportList()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                // let currInstance = localStorage.getItem('currentInstanceId');
                // this.mgmtApi.getReportListByInstance(currInstance).subscribe(
                (result) => {
                    if (result.response) {
                        this.defaultReport = result?.response.filter((m) => m.isCustom == false);
                        this.customReport = result.response.filter((m) => m.isCustom == true);
                    }
                    this.cd.detectChanges();
                    this.ngxUiLoaderService.stop();
                },
                (error) => {
                    console.error('Error fetching data:', error);
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    changeIsfavouriteHandler(data: ReportList) {
        this.reportApiService
            .saveIsfavourite([data])
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (response: any) => {
                    if (response.success) {
                        this.LoadReportList();
                        this.cd.detectChanges();
                    } else {
                        this.customToastService.errorToast(response.message, 'Error');
                    }
                },
                (error) => {
                    this.customToastService.errorToast(this.transLocoService.translate(`PLANT_MANAGER.ErrorWhileSave`), 'Error');
                }
            );
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
